<template>
  <div>
    <div class="d-inline-block w-50 mt-1">
      <title-bread-crumb :page="page" :has-route="true" />
    </div>
    <router-view />
  </div>
</template>

<script>
import TitleBreadCrumb from 'TitleBreadCrumb';

export default {
  name: 'UserRequestsWrapper',
  components: { TitleBreadCrumb },
  data: () => ({
    page: {
      title: 'Solicitud de Cuenta Usuario',
      icon: 'fas fa-user-cog',
      routes: ['Inicio', 'Usuario', 'Solicitud de Cuenta de Usuario'],
    },
  }),
  provide() {
    return {
      page: this.page,
    }
  }, 
}
</script>